import {
  Component,
  EventEmitter,
  Input,
  Output } from '@angular/core';

import { CompanyService }                from '../../companies/company.service';
import { TransactionCenterJobModel }     from '../models/transaction-center.job';

@Component({
  template: require('./transaction-center.job.row.expand.component.html')
})
export class JobRowExpandComponent {
  @Input() record: TransactionCenterJobModel;

  @Output() onEditClick : EventEmitter<TransactionCenterJobModel> = new EventEmitter();
  @Output() onLaborClick: EventEmitter<TransactionCenterJobModel> = new EventEmitter();
  @Output() onSMSClick  : EventEmitter<TransactionCenterJobModel> = new EventEmitter();

  constructor (
    public companyService: CompanyService
  ) {}
}